import { FlexBoxProps, FlexBox } from '@ardoq/layout';
import { ReactNode } from 'react';
import styled from 'styled-components';

const ButtonGroupFlexBox = styled(FlexBox)``;

export const BUTTON_GROUP_SELECTOR = ButtonGroupFlexBox.toString();

type ButtonGroupProps = Pick<FlexBoxProps, 'justify'> & { children: ReactNode };

export const ButtonGroup = ({ justify, children }: ButtonGroupProps) => (
  <ButtonGroupFlexBox gap="small" align="center" justify={justify}>
    {children}
  </ButtonGroupFlexBox>
);
